import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { userCanEditGroup } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { editGroup } from '../actions/GroupMenuActions';
import { IGroupInfo } from '../models/IGroupInfo';

export const GroupEditAction: IEntityAction<IGroupInfo, {}> = {
  name: EntityActionNames.EditGroup,
  translateName: Messages.editGroup_action,
  isVisible: (targetItems: IGroupInfo[], state: AppState) => {
    if (state.spaceInfo.spaceType === 'group' || state.spaceInfo.spaceType === 'groups') {
      return FeatureFlags.editGroupRedesignEnabled
      && targetItems.length === 1
      && isLocalGroup(targetItems[0]);
    }
    return false;
  },
  isClickable: (availableActions: {}, targetItems: IGroupInfo[], state: AppState) => userCanEditGroup(state, targetItems),
  createReduxAction: (targetItems: IGroupInfo[]) => editGroup(targetItems[0])
};

function isLocalGroup(group: IGroupInfo): boolean {
  return (group.domainName === undefined || group.domainName === 'local');
}